/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {isBrowser as ɵa} from './lib/root';